import { sanitize } from "isomorphic-dompurify";
import { BrandInfo } from "src/molecules/BrandInfo";
import { Modal } from "src/atoms/Modal";
import type { BrandData } from "src/types/adapters/browse.type";

interface BrandInfoModal {
  brand: BrandData;
  open: boolean;
  loading?: boolean;
  onClose: () => void;
}

const BrandInfoModal = ({
  open,
  brand,
  loading,
  onClose,
}: BrandInfoModal): JSX.Element => {
  return (
    <>
      <Modal isOpen={open} onClose={onClose} overFlow="hidden">
        <BrandInfo brandInfo={brand} onClose={onClose} pageType="brandsPage" />
      </Modal>
      {/* Modal only mounts client-side, so this keeps the description in the server-rendered HTML. */}
      {brand.about_brand_text ? (
        <div
          hidden
          data-testid="brand-info-ssr-description"
          dangerouslySetInnerHTML={{
            __html: sanitize(brand.about_brand_text),
          }}
        />
      ) : null}
    </>
  );
};

export { BrandInfoModal };
